module.exports = __webpack_public_path__ + "static/img/11.2a24acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/11.png
// module id = djGV
// module chunks = 0